import(/* webpackMode: "eager", webpackExports: ["Whitepaper"] */ "/vercel/path0/modules/whitepaper/Whitepaper.tsx");
